import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CommandService} from '@core/services/command.service';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {TaskManagerService} from '../../task-manager/services/task-manager.service';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FileManagementService} from '@core/services/file-management.service';
import {Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {AuthApiService} from '@core/services/auth-api.service';
import {GridValueChangeEvent} from '@shared/models/common.models';
import {Api} from '@shared/constants/common-field.constants';

@Injectable({
  providedIn: 'root',
})
export class OrbitaxConnectToolHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;

  constructor(private httpClient: HttpClient,
              private commandService: CommandService,
              private taskManagerService: TaskManagerService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private authApiService: AuthApiService,
              private fileManagementService: FileManagementService,
              protected store: Store<IQueryState>) {
    this.magicLinkModelValueChanged = new EventEmitter<any>();
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand) {
    this.executeCommandApi(command);
  }

  private executeCommandApi(command: PlatformCommand) {
    console.log('[Executing PlatformCommand] -> ', command.name);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(res => {
          console.log('Command Response', res);
          this.fuseSplashScreenService.hide();
          if (res.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(res.fieldValues['RedirectUrl']);
            return;
          }
          if (res.fieldValues['RedirectAbsoluteUrl']) {
            this.authApiService.logoutUser(res.fieldValues['RedirectAbsoluteUrl']);
            return;
          }
          if (res.fieldValues['RedirectCommand']) {
            this.executeCommand(res.fieldValues['RedirectCommand']);
            return;
          }
          if (res.fieldValues['SnackBarMessage']) {
            const duration = res.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(res.fieldValues['SnackBarMessage'], duration);
          }
          if (res.fieldValues['PlatformCommand']) {
            const commandToExecute = res.fieldValues['PlatformCommand'];
            this.executeCommand(commandToExecute);
            return;
          }
          if (res.fieldValues['PlatformLinkModel']) {
            this.magicLinkModelValueChanged.emit({id: 'PlatformToolContainerComponent', value: res.fieldValues['PlatformLinkModel']});
          }
          this.invalidateSubject.invalidate();
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  private handleActions($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'InvokeConnection':
        const runPipelineCommand = this.magicLinkModel.additionalCommands[$event.action.id];
        runPipelineCommand.fieldValues['PipelineItemId'] = $event.item.id;
        runPipelineCommand.projectId = '[PROJECT_ID]';
        this.executeCommandApi(runPipelineCommand);
        break;

      case 'ViewConnection':
        const command = this.magicLinkModel.additionalCommands['ConnectionName'];
        if (command) {
          command.fieldValues['ItemId'] = $event.item.id;
          this.executeCommandApi(command);
        }

      default:
        if (this.magicLinkModel.additionalCommands[$event.action.id]) {
          const command = this.magicLinkModel.additionalCommands[$event.action.id];
          command.fieldValues['ItemId'] = $event.item.id;
          this.executeCommand(command);
        }
        break;
    }
  }

  valueChanged($event) {
    console.log('[Event]', $event);
    if ($event.action) {
      this.handleActions($event);
      return;
    }
    if($event.dialogDefinitions) {
       for (const dialogDefinition of $event.dialogDefinitions) {
          for (const field of dialogDefinition.fields) {
          this.magicLinkModel.tabBar.nextButtonCommand.fieldValues[field.key] = field.value
        }
      }
    }
    if (this.magicLinkModel.additionalCommands[`${$event.fieldDefinition.key}LinkCommand`]) {
      const command = this.magicLinkModel.additionalCommands[`${$event.fieldDefinition.key}LinkCommand`];
      if (command) {
        command.fieldValues['ItemId'] = $event.item.id;
        command.fieldValues['FieldKey'] = $event.fieldDefinition.key;
        const workflow = $event.item.cells.Workflow.value;
        if (workflow) {
          command.fieldValues['FlowId'] = workflow.executionId ? workflow.executionId : workflow.templateId;
        }
        this.executeCommand(command);
      }

    }
    if ($event.fieldDefinition && $event.fieldDefinition.key) {
      const command = this.magicLinkModel.additionalCommands[$event.fieldDefinition.key];
      if (command) {
        command.fieldValues['ItemId'] = $event.item.id;
        this.executeCommandApi(command);
      }
    }
  }
}
